import { Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Minus } from 'lucide-react'
import React from 'react'
import { useIntl } from 'react-intl'

export type C1EmptyIndicatorProps = {
    message?: React.ReactElement
    ariaLabel?: string
}

export const C1EmptyIndicator: React.FC<C1EmptyIndicatorProps> = ({ message, ariaLabel }) => {
    const intl = useIntl()

    return message
        ? <Typography variant="disabled">{message}</Typography>
        : <Typography variant="disabled">
            <C1Icon
                icon={Minus}
                size="sm"
                aria-label={ariaLabel ?? intl.formatMessage({ id: 'components_empty_indicator_aria_label', defaultMessage: 'None' })}
            />
        </Typography>
}
